<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Truck Unit - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col v-if="role ==='super_admin' || role ==='trucking_company_admin' || role === 'trucking_operational_manager'" lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTruck">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTruck">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<b-row>
						<b-col md="8">
							<b-form-group label="Truck Unit" label-for="trucknameID" :label-cols="4" horizontal>
								<b-form-input class="plaintext-input" v-show="!edit" plaintext id="trucknameID" v-model="model.truck_unit" type="text"></b-form-input>
								<b-form-input class="plaintext-input" v-show="edit" id="trucknameID" v-model="model.truck_unit" type="text"></b-form-input>
							</b-form-group>

							<b-form-group v-if="role =='super_admin'" label="Trucking Company" label-for="truckingCompanyID" :label-cols="4" horizontal>
								<b-form-input class="plaintext-input" v-show="!edit" plaintext id="truckingCompanyID" v-model="model.trucking_company" type="text"></b-form-input>
								<b-form-select v-show="edit" value-field="id" text-field="trucking_company" id="truckingCompanyID" v-model="model.trucking_company_id" :options="truckingcompaniesselect"/>
							</b-form-group>

							<div slot="footer" v-if="edit">
								<b-button @click="updateTruck" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editTruck" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
							</div>
						</b-col>
					</b-row>
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import trucks_service from './trucks_service'
	import tc_service from '../trucking_companies/tc_service'

	const truckingCompanies = []
	const typeTrucks = []
	export default {
		name: 'TrucksUnit',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getTruckData()
		},
		data() {
			return {
				originalData		: null,
				updateData			: null,
				edit				: false,
				model: {
					truck_unit: '',
					trucking_company_id: null,
				},
				truckingcompaniesselect: [],
				subTitle: '',

				selectedTC: null,
				selectedType: null,
				loadingData: true,
				truckingCompanies: [],
				tabIndex: 0,
				found: false,
				notFoundMessage: 'Not found',
				role:'',
				view:true,
				trucking_company_id:''
			}
		},
		methods: {
			restoreOriginalData() {
				this.model = {
					trucking_company		: this.originalData.trucking_company,
					trucking_company_id		: this.originalData.trucking_company_id,
					truck_unit				: this.originalData.truck_unit,
				}
			},
			setupFields() {

			},
			editTruck() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			getTruckData() {
				trucks_service.getBy(this.id)
					.then(data => {
						if (data[0] === 'success') {
							this.originalData 	= data[1]
							this.updateData		= data[2]
							this.subTitle 		= this.originalData.truck_unit
							this.truckingcompaniesselect = this.updateData.trucking_companies
							this.restoreOriginalData()

							this.found 			= true
							this.loadingData 	= false

							this.role 			= data[3]
							console.log(this.role)
							this.trucking_company_id = data[4]

						} else {
								this.$swal(data[0], data[1], data[0])
								this.found = true
								this.loadingData = false
								return
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.role =='super_admin') {
					if(this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
							this.$swal('Alert!', 'Trucking Company not selected', 'warning')
							return false
					}
				}
				if (this.model.truck_unit === undefined || this.model.truck_unit.trim().length == 0) {
					this.$swal('Alert!', 'Truck Unit can not be empty', 'warning')
					return false
				} 

				return true
			},
			updateTruck() {
				if (!this.okToUpdate()) {
					return
				}
				if (this.role =='trucking_company_admin' || this.role === 'trucking_operational_manager') {
					this.model.trucking_company_id = this.trucking_company_id
				}

				trucks_service.update(this.id, this.model)
					.then(data => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								if (data[0] == 'success') {
									this.getTruckData()
								}
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit = false
			},
			deleteTruck() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Truck unit: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						trucks_service.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/trucks_units')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			getTruckingCompanies() {
				tc_service.getAll()
					.then(data => {
						this.truckingCompanies = []
						var tc_items = data.length
						for (var i = 0; i < tc_items; i++) {
							this.truckingCompanies.push({
								'value': data[1][i].id,
								'label': data[1][i].name
							})
						}
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/trucks_unit/trucks_unit.vue